export default {
  category_starScandal_name: '明星翻车现场',
  category_starScandal_title1: '明星翻车',
  category_starScandal_title2: '现场直击',
  category_starScandal_title3: '独家内幕',
  category_starScandal_subtitle: '最新收录',
  category_influencerGossip_name: '网红吃瓜',
  category_influencerGossip_title1: '网红圈',
  category_influencerGossip_title2: '风云变幻',
  category_influencerGossip_title3: '一手瓜料',
  category_influencerGossip_subtitle: '最新收录',
  category_blackMaterial_name: '黑料入口',
  category_blackMaterial_title1: '深度黑料',
  category_blackMaterial_title2: '独家追踪',
  category_blackMaterial_title3: '全网首发',
  category_blackMaterial_subtitle: '最新收录',
  category_deepFeature_title1: '深度黑料',
  category_deepFeature_title2: '独家追踪',
  category_deepFeature_subtitle: '最劲爆的深度报道，层层揭秘',
};